import { TransactionReceipt } from 'viem'

import { SerializableTransactionReceipt } from './types'

export function toSerializableReceipt(receipt: TransactionReceipt): SerializableTransactionReceipt {
  return {
    to: receipt.to ?? '',
    from: receipt.from,
    contractAddress: receipt.contractAddress ?? '',
    transactionIndex: receipt.transactionIndex,
    blockHash: receipt.blockHash,
    transactionHash: receipt.transactionHash,
    blockNumber: Number(receipt.blockNumber),
    status: receipt.status === 'success' ? 1 : receipt.status === 'reverted' ? 0 : undefined,
  }
}
